import type { ScopeKind } from "../../../../../shared/rbac/permissions";
import type { RoleRow } from "./roleRows";

export type SortKey = "name" | "createdAt";

export function filterAndSortRoles(
  rows: readonly RoleRow[],
  scopeFilter: ScopeKind,
  search: string,
  sort: SortKey
): RoleRow[] {
  const lowerSearch = search.toLowerCase();
  const filtered = rows.filter((r) => {
    if (r.scope !== scopeFilter) return false;
    if (lowerSearch && !r.name.toLowerCase().includes(lowerSearch))
      return false;
    return true;
  });
  filtered.sort((a, b) => {
    if (sort === "createdAt") return b.createdAt - a.createdAt;
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
  });
  return filtered;
}
